import { cn } from "@/lib/utils";

interface MethodBadgeProps {
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
}

export function MethodBadge({ method }: MethodBadgeProps) {
  const colors = {
    GET: "bg-info/10 text-info border-info/20",
    POST: "bg-success/10 text-success border-success/20",
    PUT: "bg-warning/10 text-warning border-warning/20",
    DELETE: "bg-destructive/10 text-destructive border-destructive/20",
    PATCH: "bg-kudoz/10 text-kudoz border-kudoz/20",
  };

  return (
    <span
      className={cn(
        "px-2 py-1 text-xs font-bold uppercase rounded border",
        colors[method]
      )}
    >
      {method}
    </span>
  );
}
